// $(".custom-product-cart").hover(function(){
//   $(this).find(".quick-view-new").show();
//   $(this).find(".quick-view-new").addClass("qv_active");
  
//   $(this).find(".quick-view-new.qv_active").find("button.quick--addtocart").prop('disabled', false);

//   },function(){
//    $(this).find(".quick-view-new").hide();
//   $(this).find(".quick-view-new").removeClass("qv_active");
//   $(this).find(".quick-view-new.qv_active").find("button.quick--addtocart").prop('disabled', true);
// });

$(".custom-product-cart").hover(function(){
  var $quickView = $(this).find(".quick-view-new");
  var $button = $quickView.find("button.quick--addtocart");

  $quickView.show();
  $quickView.addClass("qv_active");
  // Enable the button after a timeout
  setTimeout(function() {
    if ($quickView.hasClass("qv_active")) {
      $button.prop('disabled', false);
    }
  }, 1000); // Enable after 1 second (adjust as needed)

  }, function(){
    var $quickView = $(this).find(".quick-view-new");
    var $button = $quickView.find("button.quick--addtocart");
  
    $quickView.hide();
    $quickView.removeClass("qv_active");
    $button.prop('disabled', true);
  });

  $(window).on('load resize', function(){
    if ($(window).width() < 768) {
        console.log("reload");
      $(".custom-product-cart .card--product").addClass("active");
    
      }else
      {
       $(".custom-product-cart .card--product").removeClass("active");
      }  
    });

 $(".custom-product-cart .card--product.active ").on("click",function(e) {
      e.preventDefault();
      e.stopPropagation();
    $(this).find(".quick-view-new").show();   
  });

  $(".quick-view--close").on("click",function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parents(".quick-view-new").hide();
    $(this).parents(".quick-view-new").find("button.quick--addtocart").prop('disabled', true);
  });

  $(".quick-view--atc").on("click",function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).hide();
    $(this).siblings(".quick-view--product").css({"display":"flex"});
  });

$(".quick--addtocart").on("click",function(e){  
  e.preventDefault();
  e.stopPropagation();
  var id = $(this).attr("data-id");
  
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'id='+id+"&quantity=1",
      async:false,
      dataType: 'json',
      success: function(response) {
        console.log("add-on added!!!");
         console.log(response);
         $.ajax({
            type: 'GET',
            url: '/cart.js',
           dataType: 'json',
            success: function(cartdata){
              console.log(cartdata);
              $(".cart-link__count").html(cartdata.item_count);
              // var parsedData =  new DOMParser().parseFromString(cartdata, 'text/html').querySelector('.cart-link__count').innerHTML;
              // $('.cart-link__count').html(parsedData);        
            }
          });
          
       
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
           typeof BOLD.common.eventEmitter.emit === 'function'){
           BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded'); 
        }

        setTimeout(function(){
          BOLD.common.eventEmitter.emit('BOLD_CURRENCY_requires_augmentation');
        },1000);

        // setTimeout(function(){
        //   $(".cart-item-list__body").each(function(){
        //     var strikePrice = $(this).find(".strike_price").text();
        //     strikePrice = strikePrice.replace("$","");
        //     var innerPrice = $(this).find(".ajax-rtinnerright").text();
        //     innerPrice = innerPrice.replace("$","");
        //     console.log(innerPrice);
        //     if(strikePrice == innerPrice){
        //       $(this).find(".strike_price").removeClass("showme");
        //     }
        //     else{
        //        $(this).find(".strike_price").addClass("showme");
        //     }
        //   });
          
        //   // if($(".strike_price").text() == $(".ajax-rtinnerright").text()){
        //   //   $(".strike_price").removeClass("showme");
        //   // }
        //   // else{
        //   //    $(".strike_price").addClass("showme");
        //   // }
  
        //   var strikeSubtotal = $(".strike_price_subtotal p").text();
        //   strikeSubtotal = strikeSubtotal.replace("$","");
        //   var subtotal = $(".ajaxsubtotal").text();
        //   subtotal = subtotal.replace("$","");
          
        //   if(strikeSubtotal == subtotal){
        //     $(".strike_price_subtotal").removeClass("showme");
        //   }
        //   else{
        //     $(".strike_price_subtotal").addClass("showme");
        //   }
        // },1500);

       $(this).parents(".quick-view-new").find("button.quick--addtocart").prop('disabled', true); 
      }
    });
});

// $(document).ready(function(){
  // $(".ad-blocks .ad-block").each(function(){
  //   var target = $(this).attr("data-position");
  //   var data = $(this).find(".grid__item").get();
  //   if($("#main-collection-product-grid").find(".ad-block-item").length != 0)
  //   {
  //     target = parseInt(target) + $("#main-collection-product-grid").find(".ad-block-item").length;
  //   }
  //   if(target != undefined)
  //   {
  //     $("#main-collection-product-grid").find(".grid__item:nth-child("+parseInt(target)+")").before(data);
  //   }
  // });
// });